import { useSite } from "@/lib/site";

export const Marquee = () => {
  const { t } = useSite();
  const items = [...t.marquee, ...t.marquee];
  return (
    <div className="relative overflow-hidden border-y border-[var(--line)] bg-[var(--bg2)] py-7" data-testid="editorial-marquee">
      <div className="marquee-track flex w-max items-center">
        {items.map((m, i) => (
          <span key={i} className="flex items-center whitespace-nowrap font-display text-3xl font-black uppercase tracking-tight sm:text-5xl">
            <span className={i % 2 ? "text-transparent [-webkit-text-stroke:1px_var(--faint)]" : "text-[var(--text)]"}>{m}</span>
            <span className="mx-8 inline-block h-3 w-3 rotate-45 bg-[#8B5CF6] sm:mx-12" />
          </span>
        ))}
      </div>
    </div>
  );
};
